import { useRecoilValue } from 'recoil'
import { selectors } from 'store'

const useFooter = () => useRecoilValue(selectors.footerSelector)

export { useFooter }
